import React, {FC} from 'react';
import {useIntl} from 'react-intl';

import {ALIGN, Button, BUTTON_VARIANT, SPACE, Text, View, ViewProperties} from '@lookiero/aurora';

import {TEXT} from './FaceBookButton.definition';
import {useFaceBookButton} from './hooks/useFaceBookButton';
import {FacebookIcon} from '../../FaceBookIcon';
import {FacebookSDKResponse} from '@domain/model/Auth/AuthLoginFaceBook';

export interface FaceBookButtonProps extends ViewProperties {
  readonly onSuccess: (facebookSDKResponse: FacebookSDKResponse) => Promise<void>;
  readonly errorMessage: string;
  readonly onPress?: () => void;
}

export const FaceBookButton: FC<FaceBookButtonProps> = ({onSuccess, errorMessage, onPress, ...rest}) => {
  const {formatMessage} = useIntl();

  const {login, busy} = useFaceBookButton({onSuccess, errorMessage});

  const onPressButton = () => {
    if (onPress) onPress();
    void login();
  };

  return (
    <View {...rest}>
      <Button onPress={onPressButton} busy={busy} testID="fb-login-button" variant={BUTTON_VARIANT.SECONDARY}>
        <>
          <FacebookIcon />
          <Text align={ALIGN.CENTER} marginLeft={SPACE.SPACE_2} action>
            {formatMessage(TEXT.BUTTON_FACEBOOK)}
          </Text>
        </>
      </Button>
    </View>
  );
};
